import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from '../index'

// Layout selectors
export const selectSidebarCollapsed = (state: RootState) => state.ui.layout.sidebarCollapsed
export const selectSidebarExpandedItems = (state: RootState) => state.ui.layout.sidebarExpandedItems
export const selectActivityPanelCollapsed = (state: RootState) => state.ui.layout.activityPanelCollapsed
export const selectBottomPanelCollapsed = (state: RootState) => state.ui.layout.bottomPanelCollapsed
export const selectBottomPanelTab = (state: RootState) => state.ui.layout.bottomPanelTab

// Tab selectors
export const selectActiveTabId = (state: RootState) => state.ui.tabs.activeTabId
export const selectOpenTabs = (state: RootState) => state.ui.tabs.openTabs

export const selectActiveTab = createSelector(
  [selectOpenTabs, selectActiveTabId],
  (tabs, activeId) => tabs.find(tab => tab.id === activeId)
)

// Search selectors
export const selectSearchQuery = (state: RootState) => state.ui.search.query
export const selectSearchFilters = (state: RootState) => state.ui.search.filters

// Research selectors
export const selectResearchMessages = (state: RootState) => state.ui.research.messages
export const selectResearchIsTyping = (state: RootState) => state.ui.research.isSearching
export const selectResearchInputMessage = (state: RootState) => state.ui.research.inputValue

// Activity Log selectors
export const selectActivityLog = (state: RootState) => state.ui.activityLog

// Toast selectors
export const selectToast = (state: RootState) => state.ui.toast
export const selectToastShow = (state: RootState) => state.ui.toast.show
export const selectToastMessage = (state: RootState) => state.ui.toast.message
export const selectToastType = (state: RootState) => state.ui.toast.type